import { type WeightedUnitSystem } from "@kanpla/api-contract";

import { t } from "@repo/transifex";
import type { UnitSystem } from "~/api/products/types";

const UNIT_SYSTEM_LABELS = {
  "1-gram": "pr. 1 g",
  "100-grams": "pr. 100 g",
  kilogram: "pr. 1 kg",
  pound: "pr. 1 lb",
  ounce: "pr. 1 oz"
} as const satisfies Record<WeightedUnitSystem, string>;

/**
 * Returns a human-readable label for the unit system.
 * @param unitSystem - The unit system to get the label for
 * @returns The label for the unit system, or empty string if unitSystem is undefined or "piece"
 */
export const getUnitSystemLabel = (
  unitSystem: UnitSystem | undefined
): string => {
  if (!unitSystem || unitSystem === "piece") {
    return "";
  }

  return t(UNIT_SYSTEM_LABELS[unitSystem]);
};
